import { ViewModeSelector } from "@components/view-mode-selector/view-mode-selector";
import { useMediaQueryList } from "@hooks/use-media-query";
import { CreateProjectDialog } from "@pages/projects/create-project-dialog";

/** Returns the action buttons of the projects tab */
export function ProjectsTabActionButtons(): JSX.Element | null {
  const { isScreenSmOrSmaller } = useMediaQueryList();

  if (isScreenSmOrSmaller) {
    return null;
  }

  return (
    <>
      <ViewModeSelector subject="projects" />
      <CreateProjectDialog />
    </>
  );
}
